/* eslint-disable no-restricted-imports */
import { type ClassValue, clsx } from "clsx";
import { defineConfig } from "cva";
import { twMerge } from "./twmerge.config";

export const { cva, cx, compose } = defineConfig({
  hooks: {
    onComplete: (className) => twMerge(className),
  },
});

export { type VariantProps } from "cva";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
